import * as React from 'react';
import { Page } from 'tabler-react';
import Request from '../../shared/request';
import PageComponent from '../PageComponent';
import './admin.scss';


class AppSearch extends PageComponent {
  state = {
    app: 'ios',
    result: [],
    apps: [],
    text: '',
  };

  async componentDidMount() {
    await this.update();
    this.search();
    const s = new URLSearchParams(window.location.search);
    if (!['malus', 'lesslab'].includes(s.get('key'))) {
      window.location.href = '/';
    }
  }

  update = async (app) => {
    app = app || this.state.app;
    const response = await Request.post('getApps', {}, { 'x-malus-app': app });
    if (Array.isArray(response)) {
      this.setState({ apps: response, result: response });
    }
  }

  search = (text) => {
    text = text !== undefined ? text : this.state.text;
    const values = this.state.apps.filter((app) => !this.state.text || app.name.indexOf(text) > -1 || app.cover.indexOf(text) > -1);
    this.setState({ result: [...values] });
  }

  onSelect = (e) => {
    this.setState({ app: e.target.value });
    this.update(e.target.value);
  }

  onChange = (e) => {
    this.setState({ text: e.target.value });
    this.search(e.target.value);
  }

  render() {
    return (
      <Page.Content className="page-app-search">
        <div className="app-search-header">
          <h1>MALUS 应用搜索</h1>
          <div className="form">
            <div className="selector">
              <select name="cate" id="cate" onChange={this.onSelect}>
                <option value="ios">iOS</option>
                <option value="android">Android</option>
                <option value="windows">Windows</option>
                <option value="mac">macOS</option>
              </select>
              <i className="ri-arrow-down-s-line"></i>
            </div>

            <input type="text" placeholder='请输入应用名称' onChange={this.onChange} value={this.state.text} />
          </div>
        </div>

        <div className="app-content">
          {this.state.result.map((app) => (
            <div className="app">
              <img src={app.cover} alt="" />
              <span className='name'>{app.name}</span>
              <span className='package'>{app.package && app.package.split('.').slice(0, 3).join('.')}</span>
            </div>
          ))}
        </div>
      </Page.Content>
    );
  }
}

export default AppSearch;
